import { render, staticRenderFns } from "./SprintOption.vue?vue&type=template&id=4b5a5678&scoped=true&"
import script from "./SprintOption.vue?vue&type=script&lang=ts&"
export * from "./SprintOption.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5a5678",
  null
  
)

export default component.exports